// Utility functions extracted from the original confirmation email containers

export const parseDate = (jobData) => {
  let studioName;
  if (jobData.studio === "Studio 1") studioName = "Studio 401";
  if (jobData.studio === "Studio 2A") studioName = "Studio 403";
  if (jobData.studio === "Studio 2B") studioName = "Studio 403";
  if (jobData.studio === "Studio 2C") studioName = "Studio 403";
  if (jobData.studio === "Studio 3") studioName = "Studio 302";
  if (jobData.studio === "Studio 4") studioName = "Studio 301";

  try {
    const date = new Date(jobData.bookedStart);
    const weekDay = parseWeekDay(date.getDay());
    const day = parseDay(date.getDate());
    const month = parseMonth(date.getMonth());
    const jobType = jobData.jobTypeFull.replace(/ \(.*\)/, "").toUpperCase();
    const dayType = jobData.dayType.toUpperCase();

    const lifeRes = `${weekDay} ${day} ${month} ${jobType} ${
      jobData.multipleDays
    } ${jobData.comments ? ` ${jobData.comments}` : ""} ${dayType} ${formatAMPM(
      date
    )} - ${formatAMPM(new Date(jobData.bookedFinish))} - ${studioName}`;
    const ghostRes = `${weekDay} ${day} ${month} ${jobType}${
      jobData.multipleDays ? ` ${jobData.multipleDays}` : ""
    }${jobData.comments ? ` ${jobData.comments}` : ""} x${
      jobData.imagesScheduledToBeShot
    }`;

    let res;
    if (jobData.jobTypeFull === "Creative Life (-LC)") res = lifeRes;
    else if (jobData.jobTypeFull === "Life (-L)") res = lifeRes;
    else if (jobData.jobTypeFull === "Video (-V)") res = lifeRes;
    else res = ghostRes;

    return res;
  } catch (e) {
    console.log(e);
    console.log(jobData);
  }

  function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + ampm;
    return strTime;
  }

  function parseMonth(month) {
    if (month === 0) return "JANUARY";
    if (month === 1) return "FEBRUARY";
    if (month === 2) return "MARCH";
    if (month === 3) return "APRIL";
    if (month === 4) return "MAY";
    if (month === 5) return "JUNE";
    if (month === 6) return "JULY";
    if (month === 7) return "AUGUST";
    if (month === 8) return "SEPTEMBER";
    if (month === 9) return "OCTOBER";
    if (month === 10) return "NOVEMBER";
    if (month === 11) return "DECEMBER";
  }

  function parseDay(i) {
    var j = i % 10,
      k = i % 100;
    if (j === 1 && k !== 11) {
      return i + "ST";
    }
    if (j === 2 && k !== 12) {
      return i + "ND";
    }
    if (j === 3 && k !== 13) {
      return i + "RD";
    }
    return i + "TH";
  }

  function parseWeekDay(day) {
    if (day === 0) return "SUNDAY";
    if (day === 1) return "MONDAY";
    if (day === 2) return "TUESDAY";
    if (day === 3) return "WEDNESDAY";
    if (day === 4) return "THURSDAY";
    if (day === 5) return "FRIDAY";
    if (day === 6) return "SATURDAY";
  }
};

export const parseImages = (jobData, clientData, kind) => {
  if (kind === "dayType") {
    if (jobData[kind] === "Full Day" || jobData[kind] === "") {
      if (clientData.fullDayRate?.images) return clientData.fulldayrate?.images;
      return 240;
    } else if (jobData[kind] === "Half Day") {
      if (clientData.halfDayRate?.images) return clientData.halfDayRate.images;
      return 120;
    }
  } else if (kind === "creativeDayType") {
    if (jobData[kind] === "Full Day" || jobData[kind] === "") {
      if (clientData.contentFullDayRate?.images)
        return clientData.contentFullDayRate.images;
      return 240;
    } else if (jobData[kind] === "Half Day") {
      if (clientData.contentHalfDayRate?.images)
        return clientData.contentHalfDayRate.images;
      return 120;
    }
  }
  return 240;
};

export const parseAngles = (jobData, clientData) => {
  if (jobData.dayType === "Full Day" || jobData.dayType === "") {
    if (clientData.fulldayrate?.angles) {
      return clientData.fulldayrate?.angles;
    } else if (clientData.fulldayrate?.images) {
      if (clientData.fulldayrate?.looks) {
        return clientData.fulldayrate?.images / clientData.fulldayrate?.looks;
      } else {
        return clientData.fulldayrate?.images / 60;
      }
    } else if (clientData.fulldayrate?.looks) {
      return 240 / clientData.fulldayrate?.looks;
    }
  } else if (jobData.dayType === "Half Day") {
    if (clientData.halfDayRate.angles) {
      return clientData.halfDayRate.angles;
    } else if (clientData.halfDayRate.images) {
      if (clientData.halfDayRate.looks) {
        return clientData.halfDayRate.images / clientData.halfDayRate.looks;
      } else {
        return clientData.halfDayRate.images / 30;
      }
    } else if (clientData.halfDayRate.looks) {
      return 120 / clientData.halfDayRate.looks;
    }
  }
  return 4;
};

export const parseLooks = (jobData, clientData) => {
  if (jobData.dayType === "Full Day" || jobData.dayType === "") {
    if (clientData.fulldayrate?.looks) {
      return clientData.fulldayrate?.looks;
    } else return "60";
  } else if (jobData.dayType === "Half Day") {
    if (clientData.halfDayRate.looks) {
      return clientData.halfDayRate.looks;
    } else return "30";
  }
  return "60";
};

export const parseMarkdown = (markdown) => {
  markdown = markdown
    .replace(/^\s*$/gm, "<br>")
    .replace(
      /(<colou?r (#[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})>)(.*?)(<\/colou?r>)/gm,
      `<span style="color: $2;">$3</span>`
    )
    .replace(
      /(\*\*|__)(.*?)(\*?)\1/gm,
      `<span style="font-weight: bold;">$2</span>`
    )
    .replace(
      /(\*)(.*?)(\*?)\1/gm,
      `<span style="font-style: italic;">$2</span>`
    );
  return markdown;
};

export const getJobTypes = (mainJobData, selectedJobs = []) => {
  let tmp = [];
  // Add main job type
  const mainJobType = mainJobData.jobTypeFull.match(/^.*\((-.*)\)/)[1];
  tmp.push(mainJobType);

  // Add selected job types
  selectedJobs.forEach((job) => {
    if (job.id && job.jobTypeFull) {
      const selJobType = job.jobTypeFull.match(/^.*\((-.*)\)/)[1];
      console.log(selJobType);
      tmp.push(selJobType);
    }
  });

  // Return unique job types
  return [...new Set(tmp)];
};
